"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsScriptToken = exports.stripScriptTags = exports.normalizeWaypointDocument = exports.wrapNakedTextHtmlBlocks = exports.normalizeHtmlHeadingBlocks = exports.addExplicitBoldWeight = exports.isBoldFontWeight = exports.determineHeadingLevel = exports.stripEmailWrapperFromWaypointHtmlBlocks = exports.stripEmailWrapperRegex = exports.escapeForJsonString = exports.processTemplateVariablesAndOrgColors = exports.processWaypointTemplate = exports.isCustomHtmlBlock = exports.isVideoBlock = exports.isSocialsBlock = exports.wrapWithEmailWrapper = exports.hasEmailWrapper = exports.EMAIL_WRAPPER_STYLES = exports.applyEmailWrapperToWaypointHtmlBlocks = exports.isYoutubeVideoUrl = exports.buildConvertedVideoThumbnailHtml = exports.getYouTubeThumbnail = exports.extractYouTubeVideoId = exports.normalizeYouTubeThumbnailToHqDefault = exports.buildSocialsBlockStylingHtml = exports.calculateEmailStatPercentages = exports.getEmailFooterHtml = exports.applyMirrorHtmlNoIndex = exports.MIRROR_HTML_NOINDEX_META = exports.getEmailBodyHtml = exports.getWaypointEmailBodyHtml = exports.getEmailPreviewTextHtml = exports.isEmailMisspelled = exports.getWebsiteFromEmail = void 0;
const email_misspelled_1 = __importStar(require("email-misspelled"));
const validator_1 = require("validator");
const default_banner_urls_1 = require("../constants/default-banner-urls");
const emails_1 = require("../constants/emails");
const country_1 = require("../internationalization/enums/country");
const locales_1 = require("../internationalization/enums/locales");
const locales_2 = require("../internationalization/features/locales");
const emails_2 = require("../internationalization/locales/emails");
const photoCropUrls_1 = require("./photoCropUrls");
const colors_1 = require("./colors");
const currency_1 = require("./currency");
const dates_1 = require("./dates");
const emailEventDetails_1 = require("./emailEventDetails");
const emailEventRecapPhotos_1 = require("./emailEventRecapPhotos");
const emailOrganizationLogo_1 = require("./emailOrganizationLogo");
const string_1 = require("./string");
const templates_1 = require("./templates");
const isDomainInall = (domain) => {
    return email_misspelled_1.all.some((allDomain) => {
        return domain.includes(allDomain);
    });
};
const getWebsiteFromEmail = (email) => {
    const domainName = email.split("@").pop();
    if (domainName && isDomainInall(domainName)) {
        return null;
    }
    return domainName || null;
};
exports.getWebsiteFromEmail = getWebsiteFromEmail;
const isEmailMisspelled = (email) => {
    const emailChecker = (0, email_misspelled_1.default)({ domains: email_misspelled_1.all });
    return emailChecker(email);
};
exports.isEmailMisspelled = isEmailMisspelled;
const WAYPOINT_BACKDROP_DIV_REGEX = /(<body[^>]*>\s*)<div\s+style="([^"]*)">/i;
const EMAIL_PREVIEW_TEXT_PADDING = "&#8204;&nbsp;".repeat(100);
const getEmailPreviewTextHtml = (previewText) => {
    const trimmedPreviewText = previewText?.trim();
    if (!trimmedPreviewText) {
        return "";
    }
    return `<div style="display:none;font-size:1px;line-height:1px;max-height:0;max-width:0;opacity:0;overflow:hidden;mso-hide:all;">${(0, string_1.escapeHtml)(trimmedPreviewText)}${EMAIL_PREVIEW_TEXT_PADDING}</div>`;
};
exports.getEmailPreviewTextHtml = getEmailPreviewTextHtml;
const getWaypointEmailBodyHtml = ({ body, mirrorLink, locale, backgroundColor, previewText, }) => {
    const previewTextHtml = (0, exports.getEmailPreviewTextHtml)(previewText);
    const wrapperBackgroundColor = backgroundColor ?? "#F5F5F5";
    const mirrorLinkColor = backgroundColor ? (0, colors_1.getTextColorOfHexColor)(backgroundColor) : "black";
    const mirrorLinkHtml = mirrorLink
        ? `<div style="text-align: center; padding: 16px 0 16px 0; font-family: Arial, sans-serif; font-size: 12px;">
      <a href="${mirrorLink}" style="color: ${mirrorLinkColor}; text-decoration: underline;" target="_blank">
        ${emails_2.EMAIL_MIRROR_LINK_TEXT[locale]}
      </a>
    </div>`
        : "";
    const backdropMatch = body.match(WAYPOINT_BACKDROP_DIV_REGEX);
    if (backdropMatch && /background-color\s*:/i.test(backdropMatch[2])) {
        const [fullMatch, bodyOpenAndWhitespace, divStyle] = backdropMatch;
        // Restore the 18px vertical frame the legacy outer wrap used to provide (Waypoint canvas now ships with padding:0).
        const patchedStyle = divStyle
            .replace(/background-color\s*:\s*[^;"]+/i, `background-color: ${wrapperBackgroundColor}`)
            .replace(/padding:\s*0\b/, "padding: 18px 0");
        return body.replace(fullMatch, () => `${bodyOpenAndWhitespace}${previewTextHtml}<div style="${patchedStyle}">${mirrorLinkHtml}`);
    }
    // Legacy body shape (no <body> + backdrop div) — fall back to the outer-wrap so we don't drop the background color or mirror link.
    if (!mirrorLink) {
        return `${previewTextHtml}<div style="background-color: ${wrapperBackgroundColor}; padding: 18px 0;">${body}</div>`;
    }
    const bodyWithMirrorLink = body.replace(/(<div\s+style="[^"]*background-color[^"]*">)/, `$1${mirrorLinkHtml}`);
    return `${previewTextHtml}<div style="background-color: ${wrapperBackgroundColor}; padding: 18px 0;">${bodyWithMirrorLink}</div>`;
};
exports.getWaypointEmailBodyHtml = getWaypointEmailBodyHtml;
const getEmailBodyHtml = ({ body, backgroundColor, mirrorLink, locale, contentWidth, }) => {
    const hasBackground = !!backgroundColor;
    const wrapperBackgroundColor = backgroundColor ?? "#F9F9F9";
    const bodyBackgroundColor = backgroundColor ?? "#FFFFFF";
    // Determine mirror link color based on background luminance
    const mirrorLinkColor = backgroundColor ? (0, colors_1.getTextColorOfHexColor)(backgroundColor) : "black";
    const mirrorLinkHtml = mirrorLink
        ? `
    <div style="text-align: center; padding: 8px 0 16px 0; font-family: Arial, sans-serif; font-size: 12px;">
      <a href="${mirrorLink}" style="color: ${mirrorLinkColor}; text-decoration: underline;" target="_blank">
        ${emails_2.EMAIL_MIRROR_LINK_TEXT[locale]}
      </a>
    </div>
  `
        : "";
    return `
<div style="background-color: ${wrapperBackgroundColor}; padding: 18px 0;">
<table width="100%" role="content-container" align="center" cellpadding="0" cellspacing="0" border="0">
  <tr>
    <td width="100%">
      <table width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td>
            <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%; max-width:${contentWidth || "600px"};" align="center">
              <tr>
                <td style="${!hasBackground ? "border-radius: 8px;" : ""} padding:18px 14px 18px 14px; line-height:22px; text-align:inherit; background-color: ${bodyBackgroundColor};" role="module-content">
                  ${mirrorLinkHtml}
                  <div style="${hasBackground ? "border-radius: 8px;" : ""} box-sizing: border-box ; padding-top: 0px ; padding-right: 0px ; padding-bottom: 0px ; padding-left: 0px ; margin-top: 0px ; margin-right: 0px ; margin-bottom: 0px ; margin-left: 0px ; font-style: inherit ; font-weight: inherit ; font-stretch: inherit ; line-height: inherit ; font-size: 14px ; vertical-align: baseline ; border-top-width: 0px ; border-right-width: 0px ; border-bottom-width: 0px ; border-left-width: 0px ; color: #3c4858 ; letter-spacing: normal ; text-indent: 0px ; text-transform: none ; white-space: normal ; word-spacing: 0px ; background-color: rgb(255 , 255 , 255) ; float: none ; display: inline ; font-family: &quot;arial&quot; , &quot;helvetica&quot; , sans-serif">
                    ${body}
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
</div>`;
};
exports.getEmailBodyHtml = getEmailBodyHtml;
// "View in browser" mirror pages are hosted as raw HTML on a public S3 bucket; a robots <meta>
// in the document head is the only crawl directive search engines honor for those objects.
exports.MIRROR_HTML_NOINDEX_META = '<meta name="robots" content="noindex, nofollow, noarchive, noimageindex" />';
const applyMirrorHtmlNoIndex = (html) => {
    if (html.includes(exports.MIRROR_HTML_NOINDEX_META)) {
        return html;
    }
    if (/<head(?:\s[^>]*)?>/i.test(html)) {
        return html.replace(/<head(?:\s[^>]*)?>/i, (match) => `${match}${exports.MIRROR_HTML_NOINDEX_META}`);
    }
    if (/<html[^>]*>/i.test(html)) {
        return html.replace(/<html[^>]*>/i, (match) => `${match}<head>${exports.MIRROR_HTML_NOINDEX_META}</head>`);
    }
    return `<!DOCTYPE html><html><head>${exports.MIRROR_HTML_NOINDEX_META}</head><body style="margin:0;padding:0;">${html}</body></html>`;
};
exports.applyMirrorHtmlNoIndex = applyMirrorHtmlNoIndex;
const getEmailFooterHtml = ({ locale, unsubscribeUrl, contentWidth, backgroundColor, }) => {
    const { sentWith, tagline, unsubscribe, learnMore } = emails_2.EMAIL_FOOTER_TEXT[locale];
    const maxWidth = contentWidth || "600px";
    const bgHex = backgroundColor || "#F9F9F9";
    const { textSecondaryHex } = (0, colors_1.adaptZeffyFooter)(bgHex);
    const isLightBg = (0, colors_1.relLuminance)(bgHex) > 0.45;
    const logoUrl = isLightBg ? emails_1.ZEFFY_FOOTER_LOGO_DARK : emails_1.ZEFFY_FOOTER_LOGO_LIGHT;
    return `
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="${bgHex}" style="width:100%; background-color:${bgHex};">
      <tr>
        <td align="center" bgcolor="${bgHex}" style="background-color:${bgHex}; padding: 0;">
          <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%; max-width:${maxWidth}; margin: 0 auto;">
            <tr>
              <td align="center" style="font-family: Arial, sans-serif; color: ${textSecondaryHex}; padding: 18px 40px 24px;">
                <div style="font-size: 13px; line-height: 1.4;">
                  <span style="vertical-align: middle;">${sentWith}</span>
                  <a href="https://www.zeffy.com" target="_blank" style="text-decoration: none; margin-left: 6px;">
                    <img src="${logoUrl}" alt="Zeffy" width="67" height="20" style="display: inline-block; vertical-align: middle; border: 0; outline: none;" />
                  </a>
                </div>
                <div style="font-size: 12px; line-height: 1.5; padding-top: 6px; color: ${textSecondaryHex};">
                  ${tagline}
                </div>
                <div style="font-size: 12px; line-height: 1.5; padding-top: 14px; color: ${textSecondaryHex};">
                  <a href="${unsubscribeUrl}" style="color: ${textSecondaryHex}; text-decoration: underline;">${unsubscribe}</a>
                  <span aria-hidden="true" style="margin: 0 10px;">·</span>
                  <a href="https://www.zeffy.com" target="_blank" style="color: ${textSecondaryHex}; text-decoration: underline;">${learnMore}</a>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `;
};
exports.getEmailFooterHtml = getEmailFooterHtml;
// Formats email statistics percentages with one decimal place for values between 0 and 1
const calculateEmailStatPercentages = (count, total) => {
    if (total === 0) {
        return 0;
    }
    const percentage = (count * 100) / total;
    return percentage > 0 && percentage < 1 ? parseFloat(percentage.toFixed(1)) : Math.round(percentage);
};
exports.calculateEmailStatPercentages = calculateEmailStatPercentages;
/**
 * Helper used in waypoint email builder and unlayer to waypoint converter
 * Builds the HTML string for a single social platform link (png icon + table for background color)
 * Uses SOCIAL_PLATFORMS for the default URL. Icon style comes from options.
 */
const buildSocialsBlockStylingHtml = (platform, options) => {
    const url = options.url ?? emails_1.SOCIAL_PLATFORMS[platform].url;
    const { iconColor, backgroundColor } = options;
    // get the png url for the icon color
    const pngForIconColor = iconColor === "Coloured"
        ? emails_1.SOCIAL_ICON_IMAGE_URLS_COLOURED[platform]
        : iconColor === "White"
            ? emails_1.SOCIAL_ICON_IMAGE_URLS_WHITE[platform]
            : emails_1.SOCIAL_ICON_IMAGE_URLS_BLACK[platform];
    return (`<a data-social-platform="${platform}" data-icon-color="${iconColor}" data-icon-background-color="${backgroundColor}" href="${url}" style="display: inline-block; margin: 0 8px 8px; text-decoration: none; vertical-align: middle;" target="_blank" rel="noopener noreferrer">` +
        `<table cellpadding="0" cellspacing="0" border="0" style="display:inline-block;vertical-align:middle;"><tr><td style="background-color:${backgroundColor};border-radius:6px;width:40px;height:40px;text-align:center;line-height:0;">` +
        `<img src="${pngForIconColor}" width="40" height="40" alt="${platform}" style="display:block;border:none;outline:none;vertical-align:middle;">` +
        `</td></tr></table></a>`);
};
exports.buildSocialsBlockStylingHtml = buildSocialsBlockStylingHtml;
/**
 * Normalizes a YouTube thumbnail URL to use hqdefault so the onerror fallback (hqdefault → mqdefault) works.
 * Handles maxresdefault, sddefault, hqdefault, mqdefault from Unlayer or other sources.
 * Non-YouTube URLs are returned unchanged.
 */
const normalizeYouTubeThumbnailToHqDefault = (thumbnailUrl) => {
    return thumbnailUrl.replace(/^(https?:\/\/img\.youtube\.com\/vi\/[^/]+)\/(maxresdefault|sddefault|hqdefault|mqdefault)\.jpg$/i, `$1/${emails_1.YOUTUBE_THUMBNAIL_QUALITY}.jpg`);
};
exports.normalizeYouTubeThumbnailToHqDefault = normalizeYouTubeThumbnailToHqDefault;
const extractYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};
exports.extractYouTubeVideoId = extractYouTubeVideoId;
const getYouTubeThumbnail = (url) => {
    const videoId = (0, exports.extractYouTubeVideoId)(url);
    return videoId ? `https://img.youtube.com/vi/${videoId}/${emails_1.YOUTUBE_THUMBNAIL_QUALITY}.jpg` : null;
};
exports.getYouTubeThumbnail = getYouTubeThumbnail;
/**
 * Helper used in and unlayer to waypoint converter
 * Builds the HTML string for a youtube video thumbnail (Gmail-safe: background-image on td, no position:absolute)
 * Doesn't overlay with youtube play button like in builder as unlayer thumbnails already have play button.
 */
const buildConvertedVideoThumbnailHtml = (thumbnailUrl) => {
    const normalizedUrl = (0, exports.normalizeYouTubeThumbnailToHqDefault)(thumbnailUrl);
    return `<table data-video-thumbnail-table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="height: 300px; min-height: 300px;"><tr><td align="center" valign="middle" style="background-image: url('${normalizedUrl}'); background-size: cover; background-position: center; height: 300px; min-height: 300px;"></td></tr></table>`;
};
exports.buildConvertedVideoThumbnailHtml = buildConvertedVideoThumbnailHtml;
/**
 * Helper used in waypoint email builder and unlayer to waypoint converter
 * Checks if a URL is a valid youtube video URL
 */
const isYoutubeVideoUrl = (url) => {
    return !!url && (0, validator_1.isURL)(url) && (url.includes("youtube") || url.includes("youtu.be")) ? true : false;
};
exports.isYoutubeVideoUrl = isYoutubeVideoUrl;
/**
 * Applies the email content wrapper styling to the Html blocks in waypoint templates.
 * EMAIL_WRAPPER_STYLES in emailWrapperHelpers.ts is our source of truth for email builder typography.
 * @param document - The Waypoint document to process.
 * @returns The processed Waypoint document with the email wrapper applied to the Html blocks.
 */
const applyEmailWrapperToWaypointHtmlBlocks = (document) => {
    const next = { ...document };
    for (const blockId of Object.keys(next)) {
        const block = next[blockId];
        if (!block || block.type !== "Html") {
            continue;
        }
        const contents = block.data.props?.contents;
        if (typeof contents !== "string" || contents === "") {
            continue;
        }
        if ((0, exports.isSocialsBlock)(contents) || (0, exports.isVideoBlock)(contents) || (0, exports.isCustomHtmlBlock)(contents)) {
            continue;
        }
        next[blockId] = {
            ...block,
            data: {
                ...block.data,
                props: {
                    ...block.data.props,
                    contents: (0, exports.wrapWithEmailWrapper)(contents),
                },
            },
        };
    }
    return next;
};
exports.applyEmailWrapperToWaypointHtmlBlocks = applyEmailWrapperToWaypointHtmlBlocks;
/** CSS rules for the email wrapper <style> tag, built from EMAIL_HEADING_TYPOGRAPHY.
 * Selectors are scoped to #email-content-wrapper to prevent leaking into the Lexical editor. */
const W = `#${emails_1.EMAIL_WRAPPER_ID}`;
exports.EMAIL_WRAPPER_STYLES = [
    `${W} p, ${W} h1, ${W} h2, ${W} h3, ${W} h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }`,
    `${W} > style + ul, ${W} > style + ol { margin-top: 0; }`,
    `${W} > ul:last-child, ${W} > ol:last-child { margin-bottom: 0; }`,
    `${W} p, ${W} li, ${W} ul, ${W} ol { line-height: ${emails_1.EMAIL_TEXT_LINE_HEIGHT}; }`,
    `${W} li:has(> ul), ${W} li:has(> ol) { list-style: none; }`,
    `${W} b, ${W} strong { font-weight: ${emails_1.BOLD_FONT_WEIGHT}; }`,
    `${W} h1 { font-weight: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h1.fontWeight}; font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h1.fontSize}; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h1.lineHeight}; letter-spacing: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h1.letterSpacing}; }`,
    `${W} h2 { font-weight: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h2.fontWeight}; font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h2.fontSize}; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h2.lineHeight}; letter-spacing: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h2.letterSpacing}; }`,
    `${W} h3 { font-weight: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h3.fontWeight}; font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h3.fontSize}; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h3.lineHeight}; letter-spacing: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h3.letterSpacing}; }`,
    `${W} h4 { font-weight: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h4.fontWeight}; font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h4.fontSize}; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h4.lineHeight}; letter-spacing: ${emails_1.EMAIL_HEADING_TYPOGRAPHY.h4.letterSpacing}; }`,
    `@media only screen and (max-width: 480px) {`,
    `  ${W} h1 { font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h1.fontSize} !important; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h1.lineHeight} !important; }`,
    `  ${W} h2 { font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h2.fontSize} !important; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h2.lineHeight} !important; }`,
    `  ${W} h3 { font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h3.fontSize} !important; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h3.lineHeight} !important; }`,
    `  ${W} h4 { font-size: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h4.fontSize} !important; line-height: ${emails_1.EMAIL_HEADING_TYPOGRAPHY_MOBILE.h4.lineHeight} !important; }`,
    `}`,
].join("\n");
/**
 * Checks if HTML content has the email wrapper.
 */
const hasEmailWrapper = (html) => {
    if (!html) {
        return false;
    }
    return html.includes(`id="${emails_1.EMAIL_WRAPPER_ID}"`) || html.includes(`id='${emails_1.EMAIL_WRAPPER_ID}'`);
};
exports.hasEmailWrapper = hasEmailWrapper;
/**
 * Wraps HTML content in the email wrapper div with a <style> tag.
 * The <style> tag is inlined at send time by juice (via inlineEmailStyles).
 * If content already has the wrapper, returns it unchanged.
 *
 * @param content - The HTML content to wrap
 * @returns HTML content wrapped with email styles
 */
const wrapWithEmailWrapper = (content) => {
    if (!content) {
        return content;
    }
    if ((0, exports.hasEmailWrapper)(content)) {
        return content;
    }
    return `<div id="${emails_1.EMAIL_WRAPPER_ID}"><style>${exports.EMAIL_WRAPPER_STYLES}</style>${content}</div>`;
};
exports.wrapWithEmailWrapper = wrapWithEmailWrapper;
const isSocialsBlock = (contents) => {
    if (!contents) {
        return false;
    }
    return contents.includes('data-block-type="socials"');
};
exports.isSocialsBlock = isSocialsBlock;
const isVideoBlock = (contents) => {
    if (!contents) {
        return false;
    }
    return contents.includes('data-block-type="video"');
};
exports.isVideoBlock = isVideoBlock;
const isCustomHtmlBlock = (contents) => {
    if (!contents) {
        return false;
    }
    return contents.includes('data-block-type="custom-html"');
};
exports.isCustomHtmlBlock = isCustomHtmlBlock;
/**
 * Processes a Waypoint template by replacing template variables with organization data and applying color theming,
 * then wraps Html block contents with the email wrapper.
 * Variable substitution and fallbacks are documented on {@link processTemplateVariablesAndOrgColors}.
 * @returns The processed Waypoint template.
 */
const processWaypointTemplate = (params) => {
    const result = (0, exports.processTemplateVariablesAndOrgColors)(params);
    return (0, exports.applyEmailWrapperToWaypointHtmlBlocks)(result);
};
exports.processWaypointTemplate = processWaypointTemplate;
const formatTodaysDate = (locale, date = new Date()) => {
    const format = emails_2.EMAIL_TODAYS_DATE_FORMAT[locale] ?? emails_2.EMAIL_TODAYS_DATE_FORMAT[locales_1.Locales.EN];
    return (0, dates_1.formatDateTimeToFormat)(date, locale, format);
};
const resolveOrganizationCountry = (organization, organizationCountry) => {
    if (organizationCountry) {
        return organizationCountry;
    }
    return organization?.country && organization.country in country_1.ORGANIZATION_COUNTRY_MAP
        ? organization.country
        : undefined;
};
const buildFormProgressAmountFormatter = (organization, locale, organizationCountry) => {
    const resolvedCountry = resolveOrganizationCountry(organization, organizationCountry);
    const isoLocale = (0, locales_2.getIsoLocaleFromCountry)(resolvedCountry, locale);
    const currency = (0, currency_1.getCurrencyFromCountry)(resolvedCountry);
    return (valueInCents) => (0, currency_1.formatCurrencyFromCents)(valueInCents, { isoLocale, currency });
};
/**
 * Replaces template variables in an email builder template with organization data and applies color theming.
 * Variables use mustache-style format: {{variable_name}}
 *
 * Supported variables:
 * - {{organization_name}}
 * - {{organization_address}}
 * - {{organization_country}}
 * - {{organization_logo_url}}
 * - {{form_link}}
 * - {{event_date}} (falls back to localized "Event date" placeholder copy when no value is provided)
 * - {{event_location}} (falls back to localized "Event location" placeholder copy when no value is provided)
 * - {{event_time}} (falls back to localized "Event time" placeholder copy when no value is provided)
 * - {{form_banner_url}} (falls back to the form category's default banner when the form has no banner)
 * - {{todays_date}} (today's date, localized: "March 12 2026" in EN, "12 mars 2026" in FR)
 * - {{event_name}} (falls back to localized "the event" placeholder copy when no value is provided)
 * - {{form_volume}} / {{form_goal}} (localized currency amounts; fall back to demo amounts when no value is provided)
 * - {{placeholder_title}} / {{placeholder_description}} / {{placeholder_image_caption}} /
 *   {{placeholder_body_text}} / {{placeholder_button_label}} (localized demo copy of the prebuilt blocks)
 *
 * All fallbacks above apply in "preview" mode (the default); with `variableMode: "send"` missing values
 * resolve to empty strings instead — see {@link ProcessWaypointTemplateParams.variableMode}.
 *
 * Color theming: If a color is provided, Zeffy brand colors in the template will be replaced
 * with colors derived from the provided color (form color or organization color).
 */
const processTemplateVariablesAndOrgColors = ({ template, organization, color, formLink, eventName, eventDate, eventLocation, eventTime, formBannerUrl, formCategory, formVolumeInCents, formGoalInCents, eventRecapPhotos, organizationCountry, locale = locales_1.Locales.EN, variableMode = "preview", }) => {
    const workingTemplate = JSON.parse(JSON.stringify(template));
    (0, emailEventDetails_1.applyEventDetailVariablesIfPresent)(workingTemplate, {
        location: Boolean(eventLocation),
        date: Boolean(eventDate),
        time: Boolean(eventTime),
    });
    (0, emailEventRecapPhotos_1.applyEventRecapPhotosIfResolved)(workingTemplate, eventRecapPhotos);
    (0, emailEventRecapPhotos_1.applyNewsletterPhotosIfResolved)(workingTemplate, eventRecapPhotos);
    const organizationLogoUrl = organization?.logoUrl || "";
    if (!organizationLogoUrl) {
        (0, emailOrganizationLogo_1.removeOrganizationLogoBlocks)(workingTemplate);
    }
    let result = JSON.stringify(workingTemplate);
    const eventPlaceholders = emails_2.EMAIL_EVENT_PLACEHOLDER_COPY[locale] ?? emails_2.EMAIL_EVENT_PLACEHOLDER_COPY[locales_1.Locales.EN];
    const prebuiltBlockPlaceholders = emails_2.EMAIL_PREBUILT_BLOCK_PLACEHOLDER_COPY[locale] ?? emails_2.EMAIL_PREBUILT_BLOCK_PLACEHOLDER_COPY[locales_1.Locales.EN];
    const formatFormProgressAmount = buildFormProgressAmountFormatter(organization, locale, organizationCountry);
    const fallback = (previewCopy) => (variableMode === "send" ? "" : previewCopy);
    // Render the country as its human-readable name ("United States", not the "UnitedStates" enum value).
    const organizationCountryName = organization?.country
        ? (country_1.ORGANIZATION_COUNTRY_MAP[organization.country]?.countryName ?? organization.country)
        : fallback("[org country]");
    const resolvedFormBannerUrl = formBannerUrl || (0, default_banner_urls_1.getDefaultLandscapeBannerUrl)(formCategory);
    const replacements = {
        "{{organization_name}}": (0, exports.escapeForJsonString)(organization?.name || fallback("[org name]")),
        "{{organization_address}}": (0, exports.escapeForJsonString)(organization ? (organization.address ?? "") : fallback("[org address]")),
        "{{organization_country}}": (0, exports.escapeForJsonString)(organizationCountryName),
        [emailOrganizationLogo_1.ORGANIZATION_LOGO_URL_VARIABLE]: (0, exports.escapeForJsonString)(organizationLogoUrl),
        "{{form_link}}": (0, exports.escapeForJsonString)(formLink || ""),
        "{{event_date}}": (0, exports.escapeForJsonString)(eventDate || fallback(eventPlaceholders.date)),
        "{{event_location}}": (0, exports.escapeForJsonString)(eventLocation || fallback(eventPlaceholders.location)),
        "{{event_time}}": (0, exports.escapeForJsonString)(eventTime || fallback(eventPlaceholders.time)),
        "{{form_banner_url}}": (0, exports.escapeForJsonString)((0, photoCropUrls_1.buildLandscapePhotoUrl)(resolvedFormBannerUrl)),
        "{{todays_date}}": (0, exports.escapeForJsonString)(formatTodaysDate(locale)),
        "{{event_name}}": (0, exports.escapeForJsonString)(eventName || fallback(eventPlaceholders.name)),
        "{{placeholder_title}}": (0, exports.escapeForJsonString)(prebuiltBlockPlaceholders.title),
        "{{placeholder_description}}": (0, exports.escapeForJsonString)(prebuiltBlockPlaceholders.description),
        "{{placeholder_image_caption}}": (0, exports.escapeForJsonString)(prebuiltBlockPlaceholders.imageCaption),
        "{{placeholder_body_text}}": (0, exports.escapeForJsonString)(prebuiltBlockPlaceholders.bodyText),
        "{{placeholder_button_label}}": (0, exports.escapeForJsonString)(prebuiltBlockPlaceholders.buttonLabel),
        "{{form_volume}}": (0, exports.escapeForJsonString)(formVolumeInCents !== null && formVolumeInCents !== undefined
            ? formatFormProgressAmount(formVolumeInCents)
            : fallback(formatFormProgressAmount(emails_1.EMAIL_FORM_VOLUME_PLACEHOLDER_CENTS))),
        "{{form_goal}}": (0, exports.escapeForJsonString)(formGoalInCents !== null && formGoalInCents !== undefined
            ? formatFormProgressAmount(formGoalInCents)
            : fallback(formatFormProgressAmount(emails_1.EMAIL_FORM_GOAL_PLACEHOLDER_CENTS))),
    };
    for (const [placeholder, value] of Object.entries(replacements)) {
        result = result.split(placeholder).join(value);
    }
    // Apply color theming: replace Zeffy brand colors with colors derived from org/form color
    if (color) {
        const colorMap = (0, templates_1.getTemplateColorMap)(color);
        for (const [oldColor, newColor] of Object.entries(colorMap)) {
            const regex = new RegExp(oldColor, "gi");
            result = result.replace(regex, newColor);
        }
    }
    return JSON.parse(result);
};
exports.processTemplateVariablesAndOrgColors = processTemplateVariablesAndOrgColors;
/**
 * Escapes a string for safe insertion into a JSON string.
 * Uses JSON.stringify and strips the surrounding quotes.
 */
const escapeForJsonString = (value) => {
    return JSON.stringify(value).slice(1, -1);
};
exports.escapeForJsonString = escapeForJsonString;
/**
 * Strips the email wrapper from HTML content (regex-based, works without DOM).
 * Safe for use in both server (no DOMParser) and browser environments.
 */
const stripEmailWrapperRegex = (html) => {
    if (!html) {
        return "";
    }
    const trimmed = html.trim();
    const wrapperRegex = new RegExp(`^<div\\s+id=["']${emails_1.EMAIL_WRAPPER_ID}["'][^>]*>\\s*(?:<style>[\\s\\S]*?</style>\\s*)?(.*)\\s*</div>\\s*$`, "is");
    const match = trimmed.match(wrapperRegex);
    return match ? match[1].trim() : trimmed;
};
exports.stripEmailWrapperRegex = stripEmailWrapperRegex;
/**
 * Strips the email wrapper from HTML blocks in a Waypoint document.
 * Cleans any past waypoint design configs with old styling so they don't break when opened in the updated builder.
 */
const stripEmailWrapperFromWaypointHtmlBlocks = (document) => {
    const next = { ...document };
    for (const blockId of Object.keys(next)) {
        const block = next[blockId];
        if (!block || block.type !== "Html") {
            continue;
        }
        const contents = block.data.props?.contents;
        if (typeof contents !== "string" || contents === "") {
            continue;
        }
        if ((0, exports.isSocialsBlock)(contents) ||
            (0, exports.isVideoBlock)(contents) ||
            (0, exports.isCustomHtmlBlock)(contents) ||
            !(0, exports.hasEmailWrapper)(contents)) {
            continue;
        }
        next[blockId] = {
            ...block,
            data: {
                ...block.data,
                props: {
                    ...block.data.props,
                    contents: (0, exports.stripEmailWrapperRegex)(contents),
                },
            },
        };
    }
    return next;
};
exports.stripEmailWrapperFromWaypointHtmlBlocks = stripEmailWrapperFromWaypointHtmlBlocks;
/** Matches an Html block whose contents lead with a block-level tag (so we should NOT
 * promote the block to a heading or wrap it in `<p>`). Mirrors the regex used by
 * `wrapTextContent` in `unlayerToWaypointConverter.ts` so naked-text handling stays in
 * sync between the converter (write path) and the normalizer (read path). */
const LEADING_BLOCK_LEVEL_TAG_REGEX = /^<(p|div|ul|ol|h[1-6])\b/i;
/**
 * Returns the heading level if the (already-stripped) contents start with an h1-h4 tag.
 */
const getHtmlContentsHeadingLevel = (contents) => {
    const match = contents.match(/^\s*<(h[1-4])\b/i);
    return match ? match[1].toLowerCase() : null;
};
/**
 * Determines heading level (h1, h2, h3, h4) based on font size.
 * Uses Waypoint email builder heading font sizes:
 * - h1: 40px
 * - h2: 28px
 * - h3: 22px
 * - h4: 18px
 * Thresholds are set at midpoints to categorize font sizes to the closest heading level.
 * Text blocks are converted to headings if font size is greater than 24px.
 */
const determineHeadingLevel = (fontSize) => {
    if (fontSize >= 34) {
        return "h1";
    }
    if (fontSize >= 25) {
        return "h2";
    }
    if (fontSize >= 20) {
        return "h3";
    }
    return "h4";
};
exports.determineHeadingLevel = determineHeadingLevel;
/**
 * Converts font weight to determine if it should be bold.
 * Returns true for bold (500-900), false for normal (100-400).
 * By default, returns true (bold) if undefined.
 */
const isBoldFontWeight = (fontWeight) => {
    if (fontWeight === undefined) {
        return true;
    }
    if (typeof fontWeight === "string") {
        const normalized = fontWeight.toLowerCase().trim();
        if (normalized === "bold") {
            return true;
        }
        if (normalized === "normal") {
            return false;
        }
        const numericValue = parseInt(normalized, 10);
        if (!isNaN(numericValue)) {
            return numericValue >= 500;
        }
        return true;
    }
    if (typeof fontWeight === "number") {
        return fontWeight >= 500;
    }
    return true;
};
exports.isBoldFontWeight = isBoldFontWeight;
/**
 * Pins an explicit `font-weight` on every `<b>`/`<strong>` that lacks one.
 * Idempotent: an existing `font-weight` (inline or added by a previous pass) is never overwritten.
 */
const addExplicitBoldWeight = (contents) => contents.replace(/<(b|strong)((?:\s[^>]*)?)>/gi, (match, tag, attrs) => {
    const styleAttrMatch = attrs.match(/\sstyle\s*=\s*"([^"]*)"/i);
    const existingStyle = styleAttrMatch ? styleAttrMatch[1] : "";
    if (/\bfont-weight\s*:/i.test(existingStyle)) {
        return match;
    }
    const declaration = `font-weight: ${emails_1.BOLD_FONT_WEIGHT}`;
    const mergedStyle = existingStyle ? `${existingStyle.replace(/;\s*$/, "")}; ${declaration}` : declaration;
    if (styleAttrMatch) {
        return `<${tag}${attrs.replace(/\sstyle\s*=\s*"[^"]*"/i, ` style="${mergedStyle}"`)}>`;
    }
    return `<${tag}${attrs} style="${mergedStyle}">`;
});
exports.addExplicitBoldWeight = addExplicitBoldWeight;
// Inlines EMAIL_HEADING_TYPOGRAPHY + optional text-align on every `<h1>`-`<h4>` (Outlook Word ignores `<style>` blocks); existing inline declarations win.
const inlineHeadingStyles = (contents, textAlign) => {
    return contents.replace(/<(h[1-4])([^>]*)>/gi, (match, tag, attrs) => {
        const level = tag.toLowerCase();
        const typography = emails_1.EMAIL_HEADING_TYPOGRAPHY[level];
        const styleAttrMatch = attrs.match(/\sstyle\s*=\s*"([^"]*)"/i);
        const existingStyle = styleAttrMatch ? styleAttrMatch[1] : "";
        const additions = [];
        if (textAlign && !/\btext-align\s*:/i.test(existingStyle)) {
            additions.push(`text-align: ${textAlign}`);
        }
        if (!/\bfont-size\s*:/i.test(existingStyle)) {
            additions.push(`font-size: ${typography.fontSize}`);
        }
        if (!/\bfont-weight\s*:/i.test(existingStyle)) {
            additions.push(`font-weight: ${typography.fontWeight}`);
        }
        if (!/\bline-height\s*:/i.test(existingStyle)) {
            additions.push(`line-height: ${typography.lineHeight}`);
        }
        if (!/\bletter-spacing\s*:/i.test(existingStyle)) {
            additions.push(`letter-spacing: ${typography.letterSpacing}`);
        }
        if (additions.length === 0) {
            return match;
        }
        const mergedStyle = existingStyle
            ? `${existingStyle.replace(/;\s*$/, "")}; ${additions.join("; ")}`
            : additions.join("; ");
        if (styleAttrMatch) {
            const newAttrs = attrs.replace(/\sstyle\s*=\s*"[^"]*"/i, ` style="${mergedStyle}"`);
            return `<${tag}${newAttrs}>`;
        }
        return `<${tag}${attrs} style="${mergedStyle}">`;
    });
};
/**
 * Normalizes Html heading blocks in legacy Waypoint documents:
 *  - Existing `<h1>`-`<h4>` blocks: inlines `data.style.textAlign` on the heading tag (the
 *    Lexical editor reads alignment from inline style) and snaps `data.style.fontSize` to
 *    EMAIL_HEADING_TYPOGRAPHY.
 *  - Oversized non-heading blocks (`fontSize > 24`, no leading block-level tag): promotes
 *    them to proper headings, mirroring `convertHeadingBlock` in the converter — wraps in
 *    `<h1>`-`<h4>` (level from `determineHeadingLevel`), wraps in `<strong>` when bold,
 *    inlines `text-align`, snaps `fontSize`, drops `data.style.fontWeight`.
 *
 * Idempotent. Skips socials/video blocks. Must run AFTER stripEmailWrapperFromWaypointHtmlBlocks
 * and BEFORE applyEmailWrapperToWaypointHtmlBlocks.
 */
const normalizeHtmlHeadingBlocks = (document) => {
    const next = { ...document };
    for (const blockId of Object.keys(next)) {
        const block = next[blockId];
        if (!block || block.type !== "Html") {
            continue;
        }
        const contents = block.data.props?.contents;
        if (typeof contents !== "string" || contents === "") {
            continue;
        }
        if ((0, exports.isSocialsBlock)(contents) || (0, exports.isVideoBlock)(contents)) {
            continue;
        }
        const blockStyle = (block.data.style ?? {});
        const blockTextAlign = typeof blockStyle.textAlign === "string" ? blockStyle.textAlign : undefined;
        const existingLevel = getHtmlContentsHeadingLevel(contents);
        if (existingLevel) {
            const updatedContents = inlineHeadingStyles(contents, blockTextAlign);
            const targetFontSize = parseInt(emails_1.EMAIL_HEADING_TYPOGRAPHY[existingLevel].fontSize, 10);
            const fontSizeNeedsUpdate = blockStyle.fontSize !== targetFontSize;
            if (updatedContents === contents && !fontSizeNeedsUpdate) {
                continue;
            }
            next[blockId] = {
                ...block,
                data: {
                    ...block.data,
                    style: {
                        ...block.data.style,
                        fontSize: targetFontSize,
                    },
                    props: {
                        ...block.data.props,
                        contents: updatedContents,
                    },
                },
            };
            continue;
        }
        const blockFontSize = typeof blockStyle.fontSize === "number" ? blockStyle.fontSize : undefined;
        if (blockFontSize === undefined || blockFontSize <= 24) {
            continue;
        }
        const trimmedContents = contents.trim();
        if (trimmedContents === "" || LEADING_BLOCK_LEVEL_TAG_REGEX.test(trimmedContents)) {
            continue;
        }
        const promotedLevel = (0, exports.determineHeadingLevel)(blockFontSize);
        const promotedFontSize = parseInt(emails_1.EMAIL_HEADING_TYPOGRAPHY[promotedLevel].fontSize, 10);
        const inner = (0, exports.isBoldFontWeight)(blockStyle.fontWeight)
            ? `<strong>${trimmedContents}</strong>`
            : trimmedContents;
        const promotedContents = inlineHeadingStyles(`<${promotedLevel}>${inner}</${promotedLevel}>`, blockTextAlign);
        const nextStyle = { ...block.data.style, fontSize: promotedFontSize };
        delete nextStyle.fontWeight;
        next[blockId] = {
            ...block,
            data: {
                ...block.data,
                style: nextStyle,
                props: {
                    ...block.data.props,
                    contents: promotedContents,
                },
            },
        };
    }
    return next;
};
exports.normalizeHtmlHeadingBlocks = normalizeHtmlHeadingBlocks;
/**
 * Wraps Html block contents in `<p>` when they are naked text or lead with an inline tag.
 * Mirrors `wrapTextContent` in the converter — without a block-level tag, none of the
 * wrapper's `p` / `li` / `ul` / `ol` CSS rules apply (line-height, word-wrap, margin), and
 * Lexical's HTML importer doesn't reliably auto-wrap orphan top-level text nodes.
 *
 * Idempotent. Skips socials/video and contents already starting with a block-level tag
 * (`p`, `div`, `ul`, `ol`, `h1`-`h6`). Must run AFTER `normalizeHtmlHeadingBlocks` and
 * BEFORE `applyEmailWrapperToWaypointHtmlBlocks`.
 */
const wrapNakedTextHtmlBlocks = (document) => {
    const next = { ...document };
    for (const blockId of Object.keys(next)) {
        const block = next[blockId];
        if (!block || block.type !== "Html") {
            continue;
        }
        const contents = block.data.props?.contents;
        if (typeof contents !== "string") {
            continue;
        }
        const trimmed = contents.trim();
        if (trimmed === "") {
            continue;
        }
        if ((0, exports.isSocialsBlock)(trimmed) || (0, exports.isVideoBlock)(trimmed)) {
            continue;
        }
        if (LEADING_BLOCK_LEVEL_TAG_REGEX.test(trimmed)) {
            continue;
        }
        next[blockId] = {
            ...block,
            data: {
                ...block.data,
                props: {
                    ...block.data.props,
                    contents: `<p>${trimmed}</p>`,
                },
            },
        };
    }
    return next;
};
exports.wrapNakedTextHtmlBlocks = wrapNakedTextHtmlBlocks;
/**
 * Normalizes a Waypoint document:
 * - strips any existing (potentially outdated) styling html
 * - ensures all text is wrapped in a html tag correctly
 * - adds the up to date email-wrapper
 * This ensures consistent styling and no bugs in waypoint email builder, even when loading
 * designs converted from unlayer or created in waypoint in the early rollout stages.
 */
const normalizeWaypointDocument = (document) => {
    const stripped = (0, exports.stripEmailWrapperFromWaypointHtmlBlocks)(document);
    const headingsNormalized = (0, exports.normalizeHtmlHeadingBlocks)(stripped);
    const nakedTextWrapped = (0, exports.wrapNakedTextHtmlBlocks)(headingsNormalized);
    return (0, exports.applyEmailWrapperToWaypointHtmlBlocks)(nakedTextWrapped);
};
exports.normalizeWaypointDocument = normalizeWaypointDocument;
const SCRIPT_ELEMENT_RE = /<script\b[\s\S]*?<\/script\s*>/gi;
const SCRIPT_OPEN_TAG_RE = /<script\b[^>]*>/gi;
const SCRIPT_CLOSE_TAG_RE = /<\/script\s*>/gi;
/**
 * Cloudflare blocks any request whose body contains `<script`, so email html imports with <script> tags never
 * reach the server.
 *
 * Regex rather than the DOM: `querySelectorAll("script")` cannot see inside the MSO conditional comments
 * where pasted bot-challenge scripts usually sit.
 */
const stripScriptTags = (html) => {
    let removedCount = 0;
    const drop = () => {
        removedCount += 1;
        return "";
    };
    const stripped = html
        .replace(SCRIPT_ELEMENT_RE, drop)
        .replace(SCRIPT_OPEN_TAG_RE, drop)
        .replace(SCRIPT_CLOSE_TAG_RE, drop);
    return { html: stripped, removedCount };
};
exports.stripScriptTags = stripScriptTags;
const SCRIPT_TOKEN_RE = /<\s*\/?\s*script/i;
const ENCODED_LESS_THAN_RE = /&lt;|&#0*60;|&#x0*3c;/gi;
// Cloudflare decodes entities before matching, so `&lt;script&gt;` written as visible text trips the same
// rule as a real tag. Decoding here makes this guard reject what Cloudflare would reject.
const decodeScriptEntities = (html) => html.replace(ENCODED_LESS_THAN_RE, "<");
/**
 * True when a script token survives {@link stripScriptTags} — meaning it is escaped text the reader is
 * supposed to see, not markup. Deleting it would silently change the email, so the caller refuses the
 * import instead and says why.
 */
const containsScriptToken = (html) => SCRIPT_TOKEN_RE.test(decodeScriptEntities(html));
exports.containsScriptToken = containsScriptToken;
